<section class="main-content">

<mat-card class="card-margin-top" >
  <h2>{{'finraSettings.cardTitleApplyConfigurationFinra' | translate}}</h2>
  <p class="grey-label">{{'finraSettings.cardSubTitleApplyConfigurationFinra' | translate}}</p>

  <form [formGroup]="libraryFormGroup" fxLayout="row" fxLayoutAlign="space-between center">
    <mat-form-field class="library-search" appearance="fill" fxFlex="32">
      <mat-label>{{'finraSettings.finraSettingsLibrarySearch' | translate}}</mat-label>
      <input type="text" matInput formControlName="library"  [matAutocomplete]="auto" >
      <mat-icon matSuffix>search</mat-icon>

      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        <mat-option *ngFor="let library of libraries"
                    [value]="library">
          {{library.libraryName}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <button mat-button class="btn-background-blue fw-500" (click)="applyFinraSettings()" [disabled]="this.applyConfigurationButtonDisabled">
      {{'finraSettings.form.applyButton' | translate}}
    </button>
  </form>
</mat-card>
</section>
